import { TEST_IDS } from '@va/constants';
import { useAddNotification } from '@va/dashboard/util-hooks';
import { useTranslate } from '@va/localization';
import { DNSVerificationStatusMap, VerifyDnsSection } from '@va/shared/custom-domains';
import { Button, GrayGradientDivider, Paragraph } from '@va/ui/design-system';
import { useState } from 'react';
import { CreationSteps, useCustomTrackingCodeDomainCreationCtx } from '../custom-tracking-code-domain-creation-context';

export const VerifyDnsStep = () => {
  const [dnsVerificationStatusMap, setDnsVerificationStatusMap] = useState<DNSVerificationStatusMap>({});
  const [canMoveToNextStep, setCanMoveToNextStep] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const translate = useTranslate();

  const { domain, dnsRecordsReq, closeModal, setActiveStep } = useCustomTrackingCodeDomainCreationCtx();
  const { showErrorNotification } = useAddNotification();

  return (
    <div>
      <div className='p-4 space-y-3'>
        <Paragraph>
          {translate('standalone.customDomains.trackingCode.confirmDomainChange.line1', { newDomain: domain })}
        </Paragraph>

        <VerifyDnsSection
          expectedRecordsCount={2}
          domain={domain}
          dnsRecords={dnsRecordsReq.data}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          dnsVerificationStatusMap={dnsVerificationStatusMap}
          setDnsVerificationStatusMap={setDnsVerificationStatusMap}
          buttonColor={canMoveToNextStep ? 'quaternary' : 'primary'}
          onSuccess={() => {
            setCanMoveToNextStep(true);
          }}
          onFailure={(err) => {
            setCanMoveToNextStep(false);
            showErrorNotification(undefined, err);
          }}
        />
      </div>

      <GrayGradientDivider />

      <div className='flex flex-row justify-end p-3 gap-3'>
        <Button
          className='rounded-12 flex-1'
          color='tertiary'
          text={translate('button.cancel')}
          onClick={closeModal}
          data-testid={TEST_IDS.generic.buttons.cancel}
        />
        <Button
          className='rounded-12 flex-[2_2_0%] '
          color='primary'
          disabled={!canMoveToNextStep}
          text={translate('button.confirmAndContinue')}
          onClick={() => {
            setActiveStep(CreationSteps.confirmEffects);
          }}
          data-testid={TEST_IDS.generic.buttons.apply}
        />
      </div>
    </div>
  );
};
